import { call, put, all, takeLatest } from 'redux-saga/effects';
import { toast } from 'react-toastify';

import api from '../../../services/api';
import history from '../../../services/history';
import {
  generateSuccess,
  generateFailure,
  listSuccess,
  listFailure,
} from './actions';
import { InsightsTypes } from './types';

export function* generate(action: any) {
  try {
    const body: any = {};
    if (action.payload && action.payload.dateFrom) body.dateFrom = action.payload.dateFrom;
    if (action.payload && action.payload.dateTo) body.dateTo = action.payload.dateTo;
    const response = yield call(api.post, '/insights/generate', body);
    yield put(generateSuccess(response.data));
    toast.success('Insights gerados com sucesso!');
    history.push('/insights/' + response.data._id);
  } catch (error) {
    const message =
      (error.response && error.response.data && error.response.data.error) || 'Erro ao gerar insights. Tente novamente.';
    yield put(generateFailure(message));
    toast.error(message);
  }
}

export function* list(action: any) {
  try {
    const page = (action.payload && action.payload.page) || 1;
    const response = yield call(api.get, `/insights?page=${page}`);
    yield put(listSuccess(response.data));
  } catch (error) {
    yield put(listFailure());
    toast.error('Erro ao carregar histórico de insights.');
  }
}

export default all([
  takeLatest(InsightsTypes.GENERATE_REQUEST, generate),
  takeLatest(InsightsTypes.LIST_REQUEST, list),
]);
